import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from '@folio/stripes/components';
import { TokensSection } from '@folio/stripes-template-editor';
import { useIntl } from 'react-intl';
import { SCHEDULE_CATEGORY } from './scheduleTokens';

function ScheduleTokensList({ tokens, onSectionInit, onTokenSelect }) {
  const intl = useIntl();

  return (
    <Row>
      <Col xs={6}>
        <TokensSection
          section="report"
          selectedCategory={SCHEDULE_CATEGORY}
          header={intl.formatMessage({
            id: 'ui-reports.scheduledReports.tokens.report',
            defaultMessage: 'Report Details',
          })}
          tokens={tokens.report}
          onSectionInit={onSectionInit}
          onTokenSelect={onTokenSelect}
        />
      </Col>
      <Col xs={6}>
        <TokensSection
          section="recipient"
          selectedCategory={SCHEDULE_CATEGORY}
          header={intl.formatMessage({
            id: 'ui-reports.scheduledReports.tokens.recipient',
            defaultMessage: 'Recipient',
          })}
          tokens={tokens.recipient}
          onSectionInit={onSectionInit}
          onTokenSelect={onTokenSelect}
        />
      </Col>
    </Row>
  );
}

ScheduleTokensList.propTypes = {
  tokens:        PropTypes.object.isRequired,
  onSectionInit: PropTypes.func.isRequired,
  onTokenSelect: PropTypes.func.isRequired,
};

export default ScheduleTokensList;
